import React, { Suspense } from 'react'
import './App.css';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import Header from './components/Header/Header';
// import LandingPage from './pages/LandingPage/LandingPage';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ScrollToTop from './Hooks/ScrollToTop';
import Backdrop from './components/UI/Backdrop/Backdrop'
import useFingerprint from './Hooks/Fingerprint';
import PrivateRoute from './privateRoute'
import ActiveWalletPassphrase from './Hooks/ActiveWalletPassphrase';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import GetRippleFee from './Hooks/GetRippleFee';
import AuthHook from './Hooks/AuthHook';

const Auth = React.lazy(() => import('./pages/Auth/Auth'))
const Wallet = React.lazy(() => import("./pages/Wallet/Wallet"));
const Transactions = React.lazy(() => import('./pages/Transactions/Transactions'));
const AssetManager = React.lazy(() => import('./pages/AssetManager/AssetManager'));
const Settings = React.lazy(() => import('./pages/Settings/Settings'));
const NotFound = React.lazy(() => import('./pages/NotFound/NotFound'));
const Exchange = React.lazy(() => import('./pages/Exchange/Exchange'));
const NewAssets = React.lazy(() => import('./pages/NewAssets/NewAssets'));
const WalletSetup = React.lazy(() => import('./pages/WalletSetup/WalletSetup'));
const CreateNewWallet = React.lazy(() => import('./pages/CreateNewWallet/CreateNewWallet'))
const ImportAlgoWallet = React.lazy(() => import('./pages/ImportAlgoWallet/ImportAlgoWallet'))
const VerifyAlgoWallet = React.lazy(() => import('./pages/VerifyAlgoWallet/VerifyAlgoWallet'))
const VerifyRippleWallet = React.lazy(() => import('./pages/VerifyRippleWallet/VerifyRippleWallet'))
const ImportRippleWallet = React.lazy(() => import('./pages/ImportRippleWallet/ImportRippleWallet'))
const CreateAssetCheck = React.lazy(() => import('./pages/AssetManagerRipple/CreateAssetCheck'))
const CreateEscrow = React.lazy(() => import('./pages/AssetManagerRipple/CreateEscrow'))
const CreateAssetXrp = React.lazy(() => import('./pages/NewAssets/NewAssetsRipple'))


function App() {
  
  //get unique browser ID
  useFingerprint()


  return (
    <Router>
      <div className="App">
        <AuthHook />
        <Header />
        <Backdrop />
        <ScrollToTop />
        <ActiveWalletPassphrase />
        <GetRippleFee />
        <Route
          render={({ location }) => {
            return (
              <>
                <TransitionGroup component={null}>
                  <CSSTransition
                    timeout={300}
                    classNames="page"
                    key={location.key}
                  >
                    <Suspense fallback={<Backdrop isOpen />}>
                      <Switch location={location}>
                        <Route exact path="/">
                          <Redirect to="/login" />
                        </Route>
                        <Route exact path={['/signup', '/login']} component={Auth} />
                        
                        <PrivateRoute exact path={["/wallet-setup", "/create-wallet"]}>
                          <WalletSetup />
                        </PrivateRoute>
                        <PrivateRoute exact path="/create-wallet/:wallet">
                          <CreateNewWallet />
                        </PrivateRoute>
                        <PrivateRoute exact path="/verify-wallet/algo">
                          <VerifyAlgoWallet />
                        </PrivateRoute>
                        <PrivateRoute exact path="/verify-wallet/xrp">
                          <VerifyRippleWallet />
                        </PrivateRoute>
                        <PrivateRoute exact path="/import-wallet/algo">
                          <ImportAlgoWallet />
                        </PrivateRoute>
                        <PrivateRoute exact path="/import-wallet/xrp">
                          <ImportRippleWallet />
                        </PrivateRoute>
                        <PrivateRoute exact path="/wallet">
                          <Wallet />
                        </PrivateRoute>
                        <PrivateRoute exact path="/transactions">
                          <Transactions />
                        </PrivateRoute>
                        <PrivateRoute exact path="/asset-manager">
                          <AssetManager />
                        </PrivateRoute>
                        <PrivateRoute exact path="/new-assets">
                          <NewAssets />
                        </PrivateRoute>
                        <PrivateRoute exact path="/exchange">
                          <Exchange />
                        </PrivateRoute>
                        <PrivateRoute exact path="/settings">
                          <Settings />
                        </PrivateRoute>
                        <PrivateRoute exact path="/create-asset-xrp">
                          <CreateAssetXrp />
                        </PrivateRoute>
                        <PrivateRoute exact path="/create-check-xrp">
                          <CreateAssetCheck />
                        </PrivateRoute>
                        <PrivateRoute exact path="/create-escrow">
                          <CreateEscrow />
                        </PrivateRoute>
                        <Route component={NotFound} />
                      </Switch>
                    </Suspense>
                  </CSSTransition>
                </TransitionGroup>
              </>
            )
          }}
        />
      </div>
    </Router>
  );
}

export default App;
